import React, { Component } from 'react';
import Firebase from 'firebase';
import { browserHistory } from 'react-router'
import Select from './MultiSelectFieldStores'
import SelectForms from './MultiSelectFieldForms'

class editUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.user.name,
            email: this.props.user.email,
            rut: this.props.user.rut,
            id: this.props.id,
            created_at: this.props.user.created_at,
            last_online: this.props.user.last_online,
            number: this.props.user.number
        }
        this.setFirebase = this.setFirebase.bind(this);
        this.setStores = this.setStores.bind(this);
        this.setForms = this.setForms.bind(this);
    }

    setFirebase() {
        var usersRef = Firebase.database()
            .ref('users')
            .child(this.state.id)
            .update({
                "client_id" : localStorage.client_id,
                "created_at": this.state.created_at,
                "email": this.state.email,
                "modified_at": Firebase.database.ServerValue.TIMESTAMP,
                "name": this.state.name,
                "rut": this.state.rut,
                "last_online": this.state.last_online ? this.state.last_online : "",
                "number": this.state.number ? this.state.number : ""
            }).then(resp => {
                var clients_usersRef = Firebase.database().ref('clients_users');
                var user_permissions = clients_usersRef.child(localStorage.client_id).child(this.state.id);
                var uc = {
                    forms: null,
                    stores: null
                };
                var ss = {};
                var ff = {};
                Object.values(this.state.stores).map((s) => {
                    if (s) {
                        ss[s] = true;
                    }
                });
                Object.values(this.state.forms).map((f) => {
                    if (f) {
                        ff[f] = true;
                    }
                });
                var uc = {};
                if (Object.keys(ff).length === 0) {
                    uc.forms = true;
                } else {
                    uc.forms = ff;
                }
                if (Object.keys(ss).length === 0) {
                    uc.stores = true;
                } else {
                    uc.stores = ss;
                }
                user_permissions.set(uc).then(resp => {
                    var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
                    var id = Firebase.database().ref().child('log').push().key;
                    logRef.child(id).set({
                        admin: localStorage.email,
                        timestamp: Firebase.database.ServerValue.TIMESTAMP,
                        action: "edit",
                        target: {
                            type: "user",
                            name: this.state.name
                        }
                    });
                });
            });
    }

    setStores(new_stores) {
        if (new_stores) {
            this.setState({ stores: new_stores });
        }

    }

    setForms(new_forms) {
        if (new_forms) {
            this.setState({ forms: new_forms });
        }

    }

    componentDidMount() {
        var stores_userRef = Firebase.database().ref('clients_users')
            .child(localStorage.client_id)
            .child(this.props.id)
            .child('stores')
            .once('value')
            .then(resp => {
                this.setState({ stores: Object.keys(resp.val()) });
            });
        var stores_userRef = Firebase.database().ref('clients_users')
            .child(localStorage.client_id)
            .child(this.props.id)
            .child('forms')
            .once('value')
            .then(resp => {
                this.setState({ forms: Object.keys(resp.val()) });
            });
    }

    render() {
        return (
            <div >
                <form className="form-horizontal">
                    <div className="col-sm-12">
                        <fieldset>
                            <legend>Editar datos de Usuario</legend>
                            <div className="form-group">
                                <label >RUT</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputRut"
                                    placeholder="Rut del usuario"
                                    value={this.state.rut}
                                    onChange={(e) => { this.setState({ rut: e.target.value }) }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Nombre:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputName"
                                    placeholder="nombre del usuario"
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Email:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputEmail"
                                    placeholder="Email del usuario"
                                    value={this.state.email}
                                    onChange={(e) => { this.setState({ email: e.target.value }) }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Número telefónico:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputEmail"
                                    placeholder="Número de contacto del usuario"
                                    value={this.state.number}
                                    onChange={(e) => { this.setState({ number: e.target.value }) }}
                                />
                            </div>
                            <div className="form-group">
                                <label >Tiendas:</label>
                                {this.state.stores
                                    ?
                                    <Select id={this.props.id} stores={this.state.stores} callBack={this.setStores} />
                                    :
                                    ""
                                }
                            </div>
                            <div className="form-group">
                                <label >Formularios:</label>
                                {this.state.forms
                                    ?
                                    <SelectForms id={this.props.id} forms={this.state.forms} callBack={this.setForms} />
                                    :
                                    ""
                                }
                            </div>
                            <div className="form-group">
                                <div className="text-right">
                                    <a className="btn btn-success" onClick={() => { this.setFirebase(); this.props.callBack(); }} >Guardar</a>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </form>
            </div >
        );
    }
}
export default editUser;



// WEBPACK FOOTER //
// ./src/views/users/editUser.js